import { z } from 'zod';

import { schemaApplicantAttributionBoth, schemaBigDecimal, schemaId } from '../../../utils/schema.utils';

export const SonstigeAusgabeUndMietAusgabe = z.object({
    betragMonatlich: schemaBigDecimal.nullish().default(null),
    gehoertZuAntragsteller: schemaApplicantAttributionBoth,
    id: schemaId,
});
